<script setup lang="ts">
  defineProps<{
    errors: FormError,
    submitting: boolean,
  }>()

  const emit = defineEmits<{
    (e: 'close'): void,
    (e: 'submit'): void,
  }>()

  const form = defineModel<{ buy_back_items: string[] }>({ required: true })
</script>

<template>
  <app-modal-form @submit="emit('submit')">
    <div>
      <app-input-serial-numbers
        v-model="form.buy_back_items"
        label="Masukkan No Serial Yang Dibeli Kembali" />
      <app-error-msg :msg="errors.buy_back_items" />
      <app-error-msg
        v-for="(_, i) in form.buy_back_items"
        :key="i"
        :msg="errors[`buy_back_items.${i}`]" />
    </div>

    <app-modal-footer>
      <app-button
        class="btn-gray-outline"
        @click="emit('close')">
        Batal
      </app-button>
      <app-submit
        class="btn-primary"
        :loading="submitting">
        Simpan
      </app-submit>
    </app-modal-footer>
  </app-modal-form>
</template>
